import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { getUrl } from '../../../api/api'
import { AuthTokens } from '../../../types/auth'
import { alertErrorMessage } from '../../../utils/Errors'

export const signIn = createAsyncThunk<
    AuthTokens,
    { login: string; password: string },
    ThunkConfig<string>
>('authentication/sigIn', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { login, password } = args

    try {
        const { data } = await api.post<AuthTokens>(getUrl(`/oauth/authorize`), {
            login,
            password,
        })

        return data
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('There was an error on sign in request')
    }
})
